import axios from "axios";
import { useState } from "react";
import Swal from "sweetalert2";

export const useRating = ({ roomId, setAvgRating }) => {
  const [bookingId, setBookingId] = useState("");
  const [isBookingValid, setIsBookingValid] = useState(false);
  const [showRatingModal, setShowRatingModal] = useState(false);
  const [guestInfo, setGuestInfo] = useState({
    name: "",
    comment: "",
    rating: 0,
  });

  const handleRatingSubmit = async () => {
    try {
      const [responseRating, responseReview] = await Promise.all([
        axios.post(`/api/rooms/rating/${roomId}`, {
          bookingId,
          guestName: guestInfo.name,
          rating: guestInfo.rating,
          comment: guestInfo.comment,
        }),
        axios.get(`/api/rooms/review/${roomId}`),
      ]);
      if (responseRating) {
        Swal.fire({
          title: "Success",
          text: "Rating and review submitted successfully.",
          icon: "success",
        });
      }
      setShowRatingModal(false);
      setAvgRating(responseReview.data.avgRating);
    } catch (error) {
      console.log(error);
      Swal.fire({
        title: "Error",
        text:
          error.response?.data?.message ||
          "Failed to submit rating and review.",
        icon: "error",
      });
    }
  };

  const handleValidateBooking = async () => {
    try {
      const response = await axios.post(`/api/bookings/validate`, {
        bookingId,
        roomId,
      });
      if (response.data.valid) {
        setIsBookingValid(true);
        Swal.fire({
          title: "Success",
          text: "Booking ID validated. You can now rate the room.",
          icon: "success",
        });
      } else {
        Swal.fire({
          title: "Error",
          text: "Invalid booking ID. Please try again.",
          icon: "error",
        });
      }
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: "An error occurred. Please try again.",
        icon: "error",
      });
    }
  };

  return {
    bookingId,
    isBookingValid,
    showRatingModal,
    guestInfo,
    setGuestInfo,
    handleRatingSubmit,
    handleValidateBooking,
    setBookingId,
    setShowRatingModal,
  };
};
